module.exports = __webpack_public_path__ + "img/ilutration_camera.5a69ce67.png";